// Libraries
import { accordionAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(accordionAnatomy.keys);

const baseStyle = definePartsStyle({
  button: {
    _expanded: {
      bg: 'close.active',
    },
    borderBottom: 'greyLight',
  },
  container: {
    borderTop: 'greyLight',
  },
});

export const Accordion = defineMultiStyleConfig({ baseStyle });
